/**
 * This version is provided by `@sanity/pkg-utils` at build time
 * @hidden
 * @beta
 */
export const SANITY_VERSION = process.env.PKG_VERSION || ('0.0.0-development' as string)
